import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Title from '../../common/Title';
import StyledButton from 'common/StyledButton';
import css from './LinksSection.css';
import copy from 'clipboard-copy';
import Toast from '../../common/Toast';
import { getServiceURL, getScheduleServiceURL, getRootURL } from 'utils/deepLinks';
import { getVirtualKioskDeepLink } from 'utils/kiosk';

const LinksSection = ({id, serviceCalendarEnabled, kioskUuid}) => {

  const [showToast, setShowToast] = useState(false);

  const copyProfileLink = async () => {
    try {
      await copy(getServiceURL(id));
      setShowToast(true);
    } catch (e) {
      console.warn(e);
    }
  }

  const copyKioskCheckinLink = async () => {
    try {
      await copy(getRootURL() + getVirtualKioskDeepLink(encodeURIComponent(kioskUuid)));
      setShowToast(true);
    } catch (e) {
      console.warn(e);
    }
  }

  const copyAppointmentLink = async () => {
    try {
      await copy(getScheduleServiceURL(id));
      setShowToast(true);
    } catch (e) {
      console.warn(e);
    }
  }

  return (
    <div>
      <Title text="Share Links" />
      <div className={css['buttons-container']}>
        <StyledButton asLink onClick={copyProfileLink}>Copy Profile Link</StyledButton>
        {serviceCalendarEnabled && <StyledButton asLink onClick={copyAppointmentLink}>Copy Appointment Link</StyledButton>}
        {kioskUuid && <StyledButton asLink onClick={copyKioskCheckinLink}>Copy Kiosk Check-in Link</StyledButton>}
        {showToast && <Toast message={"Link copied to your clipboard."} onTimeout={() => setShowToast(false)} />}
      </div>
    </div>
  );
}

LinksSection.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  serviceCalendarEnabled: PropTypes.bool,
  kioskUuid: PropTypes.string
};

export default LinksSection;
